// docs: https://github.com/altostra/type-validations#readme
import { enumOf, objectOf } from "@altostra/type-validations";

export const isGetCustomObjectsOnboardingStatusResult = objectOf({
  status: enumOf("not_started", "queued", "provisioning", "applying_recipe", "ready", "failed"),
});
